module.exports = __webpack_public_path__ + "img/logo-zet.73357d9a.png";